import { InboxIcon } from '@heroicons/react/24/outline';

import { cn } from '@/renderer/utils/cn';

export function Empty({
  IconComponent = InboxIcon,
  icon = null,
  title = '',
  description = '',
  className = '',
}: {
  IconComponent?:
    | React.ForwardRefExoticComponent<React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>>
    | ((props: React.ComponentPropsWithoutRef<'svg'>) => JSX.Element);
  icon?: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
}) {
  return (
    <aside
      className={cn(
        'flex h-full select-none flex-col items-center justify-center px-6 text-center',
        className,
      )}
    >
      {icon || (
        <span className="flex size-14 items-center justify-center rounded-full bg-zinc-100 dark:bg-zinc-800/60">
          <IconComponent className="size-7 stroke-1 text-zinc-400 dark:text-zinc-500" />
        </span>
      )}
      {!!title && (
        <h2 className="mt-4 text-base font-medium text-zinc-900 dark:text-white">{title}</h2>
      )}
      {!!description && (
        <p className="mt-1.5 max-w-md text-sm leading-6 text-zinc-500 dark:text-zinc-400">
          {description}
        </p>
      )}
    </aside>
  );
}
